"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inView = inView;
/**
 * Determines if an element is visible in the viewport.
 *
 * @param element
 * @param percentX
 * @param percentY
 * @returns {boolean}
 */
function inView(element, percentX, percentY) {
  var tolerance = 0.01; // needed because the rects returned by getBoundingClientRect provide the position up to 10 decimals
  if (percentX == null) {
    percentX = 100;
  }
  if (percentY == null) {
    percentY = 100;
  }

  var elementRect = element.getBoundingClientRect();
  var parentRects = [];

  while (element.parentElement != null) {
    parentRects.push(element.parentElement.getBoundingClientRect());
    element = element.parentElement;
  }

  return parentRects.every(function (parentRect) {
    var visiblePixelX = Math.min(elementRect.right, parentRect.right) - Math.max(elementRect.left, parentRect.left);
    var visiblePixelY = Math.min(elementRect.bottom, parentRect.bottom) - Math.max(elementRect.top, parentRect.top);
    var visiblePercentageX = visiblePixelX / elementRect.width * 100;
    var visiblePercentageY = visiblePixelY / elementRect.height * 100;
    return visiblePercentageX + tolerance > percentX && visiblePercentageY + tolerance > percentY;
  });
}
//# sourceMappingURL=domUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/domUtil.js
// module id = 636
// module chunks = 0